import React, { FC } from "react";
import { default as RCSteps } from "rc-steps";
import { StepsProps } from "rc-steps/es/Steps";
import cn from "classnames";

const Steps: FC<StepsProps> = ({ className, ...props }) => {
  return <RCSteps className={cn(className)} {...props} />;
};

export default Steps;
